export default __webpack_public_path__ + "static/media/branding-semibold-webfont.2adcc204.woff2";